import StudentInputForm from "./components/StudentInputForm";

function App() {
  return <StudentInputForm />;
}

export default App;
